export default class DtoSandreCode {
    constructor(object) {
        this.field = object.field
        this.code = object.code
        this.name = object.name
        this.mnemonique = object.mnemonique
        this.reference = object.reference
    }
}
